const SUBSTRING_END_PREFIX_REDUCER = 3;

function setElementText(el: HTMLElement, text: string, maxLength: number) {
  if (!text) {
    return;
  }

  if (text.length > maxLength) {
    el.textContent = text.substring(0, maxLength - SUBSTRING_END_PREFIX_REDUCER) + '...';
  } else {
    el.textContent = text;
  }
}

export default {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inserted(el: HTMLElement, binding: any) {
    if (!binding.value || !binding.value.value) {
      return;
    }

    setElementText(el, binding.value.value, binding.value.maxLength);
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  componentUpdated(el: HTMLElement, binding: any) {
    setElementText(el, binding.value.value, binding.value.maxLength);
  }
};
